<template>
  <div class="content-box">
    <div class="element-wrapper" style="background-color: white;">
      <div class="element-box">
        <div class="row d-flex justify-content-between">
          <div>
            <h5 class="form-header">Asignación de Tarea Usuario</h5>
           
          </div>    
        </div>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <CambiarTipoTareaModalComponent @refreshData="filterData()" />
            <div class="col-sm-12" >
              <br />   
              <div class="form-inline justify-content-sm-end">                
                <UsuariosSelectComponent class="col-sm-2"  @onChange="filterData()" titulo=""
                  :current="filter" />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="filterData()">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br><br>
        <TareaUsuarioTableComponent2 :dataTabla="dataTabla" />
      </div>
      <PaginationComponent :currentPage="currentPage" :data="dataTabla" @pagechanged="filterData" />
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import TareaUsuarioTableComponent2 from "@/components/wms/utilidades/Asignar_tarea_usuario/TareaUsuarioTableComponent2";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";
import CambiarTipoTareaModalComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/CambiarTipoTareaModalComponent";
import CategoriasUsuarioEdicionComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/CategoriasUsuarioEdicionComponent";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    TareaUsuarioTableComponent2,
    UsuariosSelectComponent,
    CategoriaSelectComponent,
    SubCategoriaSelectComponent,
    UsuarioEnTablaComponent,
    PaginationComponent,
    CambiarTipoTareaModalComponent,
    CategoriasUsuarioEdicionComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      dataTabla: "",
      filter: {
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        proveedor: "",
        fecha: "",
        categoria: "",
        subcategoria: "",
      },
    };
  },
  watch:{
    "filter.usuario"(val){      
      if(val === null){
        this.clearFilterData()        
      }
    }
  },
  computed: {},
  mounted() {
    this.filterData();
  },
  methods: {
    ModalCambiarTipoTarea() {
      let self = this;
      $("#cambiarTipoTareaGlobal").modal("show");
    },
    filterData(page) {
      let self = this;      
     
      if (!page) {
        page = 1;
      }
      if (self.filter.usuario == null) {
        self.filter.usuario = "";
      }     
      self.currentPage = page;
      DynamicService.getActionList("wms", "asignar-tarea-usuario", "resumen_categorias_asignadas", {
        // estatus: self.filter.estado_str,
        // tienda_destino: self.filter.tienda,
        pickeador: self.filter.usuario.id, 
        // categoria: self.filter.categoria.codigo,
        // sub_categoria: self.filter.subcategoria.codigo,
         page: page,
      }).then((response) => {   
        if(response.data.count == 1 && response.data.results[0].total == 0){          
          Notifications.alert.error("Error", "Este usuario no tiene categorias asociadas o no pertenece al equipo de picking")          
          return
        }    
        
        if(response.data.count ==0){
          Notifications.alert.error("Error", "Este usuario no tiene categorias asociadas o no pertenece al equipo de picking")
          this.filter.usuario = ""; 
        }else{
          self.dataTabla = response.data;
        }
      });
    },
    clearFilterData() {
      let self = this;    
      this.filter.usuario = "";
      DynamicService.getActionList("wms", "asignar-tarea-usuario", "resumen_categorias_asignadas", {
        pickeador: self.filter.usuario.id,
      }).then((response) => {    
        self.dataTabla = response.data;
      });
     
    },
  },
};
</script>
